import throttle from "lodash/throttle";
import { getJson } from "../helper/FetchAuthentication";
import { isValidCoordinates } from "../helper/LatLonValidation";
import AppConfig from "../../../appConfig";
import { centroid } from "@turf/turf";

export const dataLayer = {
  id: "data",
  type: "fill",
  paint: {
    "fill-color": ["get", "fill"],
    "fill-opacity": ["get", "stroke-opacity"],
  },
};

export const symboldataLayer = {
  id: "lable-data",
  type: "symbol",
  layout: {
    "icon-image": "harbor-15",
    "icon-allow-overlap": true,
    "text-field": ["get", "title"],
  },
};

export function makeGeoJsonData(featureCollection) {
  const { features } = featureCollection;

  const featuresLables = features.map((feature) => {
    let centroidPt = centroid(feature);
    centroidPt.properties = {
      title: feature.title ? feature.title : "",
    };
    return centroidPt;
  });

  const featureCollectionJson = {
    type: "FeatureCollection",
    features: features.map((f) => {
      const properties = {
        ...f.properties,
        customLayer: "",
      };
      return { ...f, properties };
    }),
  };
  const featureCollectionLablesJson = {
    type: "FeatureCollection",
    features: featuresLables,
  };
  return {
    featureCollection: featureCollectionJson,
    featureLablesCollection: featureCollectionLablesJson,
  };
}

export const loadTilesAsync = async (accessToken, memberId) => {
  const url = `${AppConfig.baseUrl()}/services/server-tiles?memberId=${memberId}`;
  return await getJson(url, accessToken);
};
export const getStaticUrl = (filePath) => {
  return `${AppConfig.baseUrl()}/static/v${AppConfig.version}/${filePath}`;
};

export const getMapUrl = (type) => {
  const baseUrl = `${AppConfig.baseUrl()}/services/style`;
  return `${baseUrl}?name=${type}`;
};

export const loadGeoJsonAsync = async (accessToken, styleId) => {
  const url = `${AppConfig.baseUrl()}/services/layers?styleId=${styleId}`;
  const data = await getJson(url, accessToken);
  return data;
};

export const loadIntialDataAsync = async (accessToken, memberId, defaultMap) => {
  const maptiles = await loadTilesAsync(accessToken, memberId);

  const styleId = (defaultMap && maptiles.some((m) => m.id === defaultMap))? defaultMap : (maptiles.length > 0 ? maptiles[0].id : "");

  const data = await loadGeoJsonAsync(accessToken, styleId);

  return {
    data,
    maptiles,
  };
};

export const searchAddress = throttle(async (accessToken, input, callback) => {
  if (!input) {
    callback([]);
    return;
  }
  const url = `${AppConfig.baseUrl()}/geocoding/query?query=${encodeURI(
    input
  )}`;
  const data = await getJson(url, accessToken);
  callback(data);
}, 2000);

// profile : bike,motobike,car,foot
export const getDirectionAsync = async (accessToken, profile, start, end) => {
  switch (profile) {
    case "bike":
    case "motobike":
    case "car":
    case "foot":
      break;
    default: {
      console.error("profile is not correct !");
      return;
    }
  }

  const isStartValid = isValidCoordinates(start.longitude, start.latitude);
  if(!isStartValid) {
    console.error("start position is not correct !");
    return {};
  }
  
  const isEndValid = isValidCoordinates(end.longitude, end.latitude);
  if(!isEndValid) {
    console.error("end position is not correct !");
    return {};
  }

  const url = `${AppConfig.baseUrl()}/directions/basic/${profile}/${start.longitude},${start.latitude}/${end.longitude},${end.latitude}`;
  const data = await getJson(url, accessToken);
  return data;
};

export const generateKey = (pre) => {
  return `${ pre }_${new Date().getTime() }`;
}
